'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TagGroup", {
    enumerable: true,
    get: function() {
        return TagGroup;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useTagGroup = require("./useTagGroup");
const _renderTagGroup = require("./renderTagGroup");
const _useTagGroupStylesstyles = require("./useTagGroupStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const _useTagGroupContextValues = require("./useTagGroupContextValues");
const TagGroup = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useTagGroup.useTagGroup_unstable)(props, ref);
    (0, _useTagGroupStylesstyles.useTagGroupStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useTagGroupStyles_unstable')(state);
    return (0, _renderTagGroup.renderTagGroup_unstable)(state, (0, _useTagGroupContextValues.useTagGroupContextValues_unstable)(state));
});
TagGroup.displayName = 'TagGroup';
